import { render, staticRenderFns } from "./UnlayerEmailWizardContainer.vue?vue&type=template&id=995049dc&scoped=true"
import script from "./UnlayerEmailWizardContainer.vue?vue&type=script&lang=js"
export * from "./UnlayerEmailWizardContainer.vue?vue&type=script&lang=js"
import style0 from "./UnlayerEmailWizardContainer.vue?vue&type=style&index=0&id=995049dc&prod&scoped=true&lang=scss"
import style1 from "./UnlayerEmailWizardContainer.vue?vue&type=style&index=1&id=995049dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "995049dc",
  null
  
)

export default component.exports